import { Button, Grow, Icon, Stack, Toolbar, Typography } from "@mui/material";
import { memo } from "react";
import { ICarrito, IInforme } from "@/redux/models";
import { modalInformeType, modalsTypes } from "../Modals";
import { useTablaCarritoV2Props, ViewAs } from "../../logics/useTablaCarritoV2";
import RepedirButton from "./RepedirButton";

interface ToolbarInformesProps {
    selected: IInforme[];
    setModal: (modal: "" | modalsTypes, data?: any) => void;
    carritos: ICarrito[];
    viewAs: useTablaCarritoV2Props['viewAs']
}

const ToolbarInformes = ({ selected, setModal, carritos, viewAs }: ToolbarInformesProps) => {
    return (
        <Toolbar>
            <legend style={{ flex: '1 1 20%', justifyContent: 'space-between' }}>
                <Typography variant="h6" gutterBottom component="div" sx={{ float: 'left' }} >
                    Informes
                </Typography>
            </legend>
            <Stack direction="row" spacing={2} flex='1' justifyContent='flex-end'>

                {ViewAs.ADMIN === viewAs &&
                    <Grow in={selected.length >= 1}>
                        <Button
                            variant="outlined"
                            startIcon={<Icon>receipt_long</Icon>}
                            onClick={() => setModal(modalInformeType.LIQUIDAR_INFORMES, {
                                informes: selected,
                                carpetas: carritos
                            })}
                        >
                            Liquidar
                        </Button>
                    </Grow>
                }
                
                <RepedirButton 
                    selectedInformes={selected}
                    isVisible={selected.length >= 1}
                />

            </Stack>
        </Toolbar >
    );
}

export default memo(ToolbarInformes, (prev, next) => prev.selected.length === next.selected.length);